<div class="minFullHeight">
    <div class="pt-10">
        <mat-spinner class="mx-auto loading" color="primary"></mat-spinner>
    </div>
</div>
